import { render } from "./ClubOfficialBlackCard.vue?vue&type=template&id=3f0c1664&scoped=true"
import script from "./ClubOfficialBlackCard.vue?vue&type=script&lang=js"
export * from "./ClubOfficialBlackCard.vue?vue&type=script&lang=js"

import "./ClubOfficialBlackCard.vue?vue&type=style&index=0&id=3f0c1664&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f0c1664"]])

export default __exports__